// src/components/Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

const Footer = () => {
  const [subEmail, setSubEmail] = useState('');
  const [subStatus, setSubStatus] = useState('idle'); // idle | loading | success | error
  const [subError, setSubError] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const trimmed = subEmail.trim().toLowerCase();
    if (!trimmed || !trimmed.includes('@')) {
      setSubError('Please enter a valid email address.');
      return;
    }
    setSubStatus('loading');
    setSubError('');
    try {
      const docId = trimmed.replace(/[.@]/g, '_');
      await setDoc(doc(db, 'readers', docId), {
        email: trimmed,
        newsletter: true,
        subscribedAt: new Date().toISOString(),
      }, { merge: true });
      setSubStatus('success');
      setSubEmail('');
    } catch (err) {
      console.error('Subscribe error:', err);
      setSubError('Something went wrong. Please try again.');
      setSubStatus('error');
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="nav-logo">
              <div className="logo-icon"><img src="/avenirlogowhite.png" alt="Avenir AI" /></div>
              <span className="logo-text">Avenir AI</span>
            </Link>
            <p>AI that turns benefits data into action.</p>
          </div>
          <div>
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Book Demo</Link></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="footer-heading">Solutions</h4>
            <ul className="footer-links">
              <li><Link to="/product">Product</Link></li>
              <li><Link to="/solutions/employers">For Employers</Link></li>
              <li><Link to="/solutions/brokers">For Brokers</Link></li>
              <li><Link to="/solutions/cfos">For CFOs</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
            </ul>
          </div>
        </div>

        {/* Newsletter Subscribe */}
        <div className="footer-newsletter">
          <div className="footer-newsletter-content">
            <div className="footer-newsletter-copy">
              <h4 className="footer-heading">The Avenir Newsletter</h4>
              <p>Weekly insights for benefits brokers, HR leaders, and CFOs. No spam.</p>
            </div>
            {subStatus === 'success' ? (
              <div className="footer-newsletter-success">
                <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                You're subscribed!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="footer-newsletter-form">
                <input
                  type="email"
                  value={subEmail}
                  onChange={(e) => { setSubEmail(e.target.value); setSubError(''); setSubStatus('idle'); }}
                  placeholder="you@company.com"
                  disabled={subStatus === 'loading'}
                  className="footer-newsletter-input"
                />
                <button
                  type="submit"
                  className="btn btn-primary footer-newsletter-btn"
                  disabled={subStatus === 'loading'}
                >
                  {subStatus === 'loading' ? (
                    <><span className="btn-spinner"></span>Subscribing...</>
                  ) : 'Subscribe'}
                </button>
              </form>
            )}
          </div>
          {subError && <p className="footer-newsletter-error">{subError}</p>}
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Avenir AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;